import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { AbstractCrudApiService } from '@shared/abstracts/abstract-crud-api.service';
import { EvaluationSurveyDto } from '@shared/dto';
import { urlJoin } from '@shared/utils/url.utils';

@Injectable({ providedIn: 'root' })
export class EvaluationSurveyApiService extends AbstractCrudApiService<EvaluationSurveyDto, never, never> {
  private _cache: EvaluationSurveyDto[] | null = null;

  override get endpoint(): string {
    return this.api$.value ?? '';
  }

  constructor() {
    super();
    this.api$.next(urlJoin(this.env.get('api.base'), 'evaluation-surveys'));
  }

  readAll(options?: { refresh?: boolean }): Observable<EvaluationSurveyDto[]> {
    if (!options?.refresh && this._cache !== null) {
      return of(this._cache);
    }
    return super.read().pipe(
      tap(surveys => {
        this._cache = Array.isArray(surveys) ? surveys : [];
      }),
    );
  }

  clearCache(): void {
    this._cache = null;
  }
}
